import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']  // hoặc .scss nếu bạn dùng scss
})
export class AppComponent {
  title = 'Manager Media'; // bạn có thể sửa hoặc bỏ nếu không cần
}
